/**
 * Preview feature constants.
 * Must match GraphQL PreviewFeature enum.
 */
export const PreviewFeature = {
    /** New Workspace 2.0 feature */
    NEW_WORKSPACE_20: 'NEW_WORKSPACE_20',
    /** Level of Specification Automation feature */
    LOS_AUTOMATION: 'LOS_AUTOMATION',
    /** Product Type Automation feature */
    PT_AUTOMATION: 'PT_AUTOMATION',
    /** OM Workspace - enables new workspace toggle for Office Master workspaces */
    OM_WORKSPACE: 'OM_WORKSPACE',
    /** OM Product Type Automation - controls PT deactivation UX in OM workspace */
    OM_PT_AUTOMATION: 'OM_PT_AUTOMATION',
    /** OM Insert Pill - enables inline pill insertion in OM workspace plain text */
    OM_INSERT_PILL: 'OM_INSERT_PILL',
    /** OM LOS Automation - shows Level of Specification icon in OM workspace */
    OM_LOS_AUTOMATION: 'OM_LOS_AUTOMATION',
    /** OM PT Link Automation - shows Product Type/Group link icons in OM workspace */
    OM_PT_LINK_AUTOMATION: 'OM_PT_LINK_AUTOMATION',
    /** API Subscription Management - enables the API Subscription section on account setup */
    API_SUBSCRIPTION_MANAGEMENT: 'API_SUBSCRIPTION_MANAGEMENT',
} as const

/** Type for preview feature values */
export type PreviewFeature = typeof PreviewFeature[keyof typeof PreviewFeature]
